import React, { useEffect, useRef, useState } from 'react';
import {
  ECardHoverOverlay,
  ECardImage,
  ECardImageWrapper,
  ECardWrapper,
} from '@components/storefront/StorefrontECard/StorefrontECard.styles';
import { Button } from '@components/Button';
import { getCardThemeId, getSignUpScenario, getUseTemplateCtaId } from '@utils/storefront.util';
import { getCardCreateWeddingUrl } from '@utils/urlHelpers.util';
import { eCardsStorefrontPageContentData } from '@data-ts/components/storefront/ECardsStorefrontPageContent';

interface Props
  extends Readonly<{
    data: StorefrontECard;
    isHovered: boolean;
  }> {}

const DEFAULT_ASPECT_RATIO = 0.72;

const getAspectRatio = (imageEl: HTMLImageElement | undefined) => {
  let aspectRatio = DEFAULT_ASPECT_RATIO;
  if (imageEl) {
    aspectRatio = imageEl.naturalWidth / imageEl.naturalHeight;
  }
  return aspectRatio;
};

const copyData = eCardsStorefrontPageContentData;

export const StorefrontECard: React.FC<Props> = ({ data, isHovered, ...props }) => {
  const [aspectRatio, setAspectRatio] = useState(DEFAULT_ASPECT_RATIO);
  const [isLoaded, setLoaded] = useState(false);
  const wrapperRef = useRef<HTMLDivElement>(null);
  const onImageLoaded = (imageEl: HTMLImageElement) => {
    setAspectRatio(getAspectRatio(imageEl));
    setLoaded(true);
  };
  useEffect(() => {
    const imageEl = wrapperRef.current?.querySelector('img');
    if (imageEl?.complete) {
      onImageLoaded(imageEl);
    }
  }, []);
  const coverSrc = data.images && data.images[0]?.originalSrc;
  // pages render only card that have themeId defined
  const themeId = getCardThemeId(data)!;
  const signUpScenario = getSignUpScenario(data.productType);
  const cardTypeLabel = copyData.eCardImageAltSuffix[data.productType];
  return (
    <ECardWrapper {...props} ref={wrapperRef}>
      <ECardImageWrapper aspectRatio={aspectRatio}>
        <ECardImage
          src={coverSrc}
          alt={`${data.title} ${cardTypeLabel}`}
          $isLoaded={isLoaded}
          $isHovered={isHovered}
          onLoad={({ currentTarget }) => {
            onImageLoaded(currentTarget);
          }}
        />
        <ECardHoverOverlay isHovered={isHovered}>
          <Button
            id={getUseTemplateCtaId(data.productType, themeId)}
            variant="primary"
            forwardedAs={'a'}
            target="_self"
            telemetryLabel={themeId}
            href={`${getCardCreateWeddingUrl(signUpScenario, themeId)}`}
          >
            {copyData.useThisTemplate}
          </Button>
        </ECardHoverOverlay>
      </ECardImageWrapper>
    </ECardWrapper>
  );
};
